// The word needs room; a narrow missing month says it by colour alone, and the title names it.
export const MissingWord = () => (
  <span className="hidden @[3.5rem]:inline">Missing</span>
)
